(function () {
  'use strict';

  var overlay  = document.getElementById('syoat-search');
  var backdrop = document.getElementById('syoat-search-backdrop');
  if (!overlay) return;

  var input       = document.getElementById('syoat-search-input');
  var closeBtn    = document.getElementById('syoat-search-close');
  var submitBtn   = overlay.querySelector('.syoat-search__submit');
  var resultsBody = document.getElementById('syoat-results-body');
  var timer;

  /* ── Open ── */
  function open() {
    overlay.style.display = 'flex';
    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); }, 200);
    });
  }

  /* ── Close ── */
  function close() {
    overlay.classList.remove('is-open');
    overlay.classList.add('is-closing');
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    input.value = '';
    resultsBody.innerHTML = '';
    setTimeout(function () {
      overlay.classList.remove('is-closing');
      overlay.style.display = 'none';
    }, 320);
  }

  /* ── Search ── */
  function doSearch(query) {
    query = query.trim();
    if (!query) { resultsBody.innerHTML = ''; return; }

    resultsBody.innerHTML = '<p class="syoat-searching">Searching...</p>';

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=8')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources &&
          data.resources.results &&
          data.resources.results.products) || [];

        if (!products.length) {
          resultsBody.innerHTML =
            '<p class="syoat-no-results">No results for &ldquo;' + esc(query) + '&rdquo;</p>';
          return;
        }

        var html = '<div class="syoat-grid">';
        products.forEach(function (p) {
          html +=
            '<a href="' + (p.url || '/products/' + p.handle) + '" class="syoat-card">' +
              '<div class="syoat-card__img">' +
                (p.image
                  ? '<img src="' + p.image + '" alt="' + esc(p.title) + '" loading="lazy">'
                  : '<div class="syoat-card__no-img"></div>') +
              '</div>' +
              '<div class="syoat-card__info">' +
                '<p class="syoat-card__title">' + esc(p.title) + '</p>' +
                (p.price ? '<p class="syoat-card__price">' + p.price + '</p>' : '') +
              '</div>' +
            '</a>';
        });
        html += '</div>';
        resultsBody.innerHTML = html;
      })
      .catch(function () {
        resultsBody.innerHTML = '<p class="syoat-no-results">Something went wrong. Try again.</p>';
      });
  }

  function esc(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str || ''));
    return d.innerHTML;
  }

  /* ── Intercept search icon on mobile ── */
  document.querySelectorAll('[data-search-trigger], .icon-only-search-trigger')
    .forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (window.innerWidth <= 960) {
          e.preventDefault();
          e.stopImmediatePropagation();
          open();
        }
      }, true);
    });

  closeBtn.addEventListener('click', close);
  backdrop.addEventListener('click', close);

  input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = this.value.trim();
    if (!q) { resultsBody.innerHTML = ''; return; }
    timer = setTimeout(function () { doSearch(q); }, 300);
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      var q = this.value.trim();
      if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
    }
    if (e.key === 'Escape') close();
  });

  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      var q = input.value.trim();
      if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.style.display !== 'none') close();
  });

})();

/* ---- Syoat Gallery Arrows + Dots v2 ---- */
(function() {
  function init() {
    const gallery = document.querySelector('.product__media-container.below-mobile .product__media');
    if (!gallery) return;

    const slides = Array.from(gallery.querySelectorAll('.product__media-item'));
    if (slides.length <= 1) return;
    if (gallery.querySelector('.syoat-arrow')) return;

    let currentIndex = 0;

    // --- Dots ---
    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'syoat-dots';
    const dots = slides.map((slide, i) => {
      const dot = document.createElement('span');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      dotsWrap.appendChild(dot);
      return dot;
    });
    gallery.parentNode.insertBefore(dotsWrap, gallery.nextSibling);

    // --- Arrows ---
    const createArrow = (side) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'syoat-arrow syoat-arrow--' + side;
      btn.setAttribute('aria-label', side === 'left' ? 'Previous image' : 'Next image');
      const points = side === 'left' ? '15 18 9 12 15 6' : '9 18 15 12 9 6';
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="' + points + '"></polyline></svg>';
      return btn;
    };

    const leftBtn = createArrow('left');
    const rightBtn = createArrow('right');
    gallery.appendChild(leftBtn);
    gallery.appendChild(rightBtn);

    const setActive = (index) => {
      if (index < 0 || index >= slides.length || index === currentIndex) return;
      currentIndex = index;
      dots.forEach((d, i) => d.classList.toggle('active', i === index));
      leftBtn.style.opacity = index === 0 ? '.35' : '1';
      leftBtn.style.pointerEvents = index === 0 ? 'none' : 'auto';
      rightBtn.style.opacity = index === slides.length - 1 ? '.35' : '1';
      rightBtn.style.pointerEvents = index === slides.length - 1 ? 'none' : 'auto';
    };

    leftBtn.addEventListener('click', () => {
      slides[Math.max(0, currentIndex - 1)].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
    rightBtn.addEventListener('click', () => {
      slides[Math.min(slides.length - 1, currentIndex + 1)].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });

    // --- Detect active slide by which one is closest to gallery center ---
    const detectActive = () => {
      const galleryRect = gallery.getBoundingClientRect();
      const centerX = galleryRect.left + galleryRect.width / 2;
      let closestIndex = 0;
      let closestDistance = Infinity;
      slides.forEach((slide, i) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(slideCenter - centerX);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });
      setActive(closestIndex);
    };

    // --- Capture-phase scroll listener catches ALL scroll events inside gallery ---
    document.addEventListener('scroll', (e) => {
      if (gallery.contains(e.target) || e.target === gallery || e.target === document) {
        requestAnimationFrame(detectActive);
      }
    }, { capture: true, passive: true });

    // --- Touch backup (mobile swipe) ---
    gallery.addEventListener('touchmove', () => requestAnimationFrame(detectActive), { passive: true });
    gallery.addEventListener('touchend', () => setTimeout(detectActive, 150), { passive: true });

    // Initial check after layout settles
    setTimeout(detectActive, 100);
    setTimeout(detectActive, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ---- Syoat Sticky ATC — Strip + Qty ---- */
(function() {
  const msgs = [
    '🚚 Free Shipping',
    '💳 100% Secure Transaction'
  ];
  let msgIdx = 0;
  let qty = 1;

  function initStickyBar() {
    const bar = document.querySelector('.sticky-atc-bar');
    const btnWrap = document.querySelector('.sticky-atc-bar__button');
    const inner = document.querySelector('.sticky-atc-bar__inner');
    if (!bar || !btnWrap || !inner) return;

    /* --- Offer Strip --- */
    if (!bar.querySelector('.syoat-strip')) {
      const strip = document.createElement('div');
      strip.className = 'syoat-strip';
      strip.textContent = msgs[0];
      bar.insertBefore(strip, bar.firstChild);

      setInterval(function() {
        strip.style.opacity = '0';
        setTimeout(function() {
          msgIdx = (msgIdx + 1) % msgs.length;
          strip.textContent = msgs[msgIdx];
          strip.style.opacity = '1';
        }, 400);
      }, 3000);
    }

    /* --- Qty Selector --- */
    if (!btnWrap.querySelector('.syoat-qty')) {
      if (!inner.querySelector('.syoat-qty-hidden')) {
        const inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'quantity';
        inp.value = '1';
        inp.className = 'syoat-qty-hidden';
        inner.appendChild(inp);
      }
      const hiddenQty = inner.querySelector('.syoat-qty-hidden');

      const wrap = document.createElement('div');
      wrap.className = 'syoat-qty';
      wrap.innerHTML = '<button type="button" class="syoat-qty__btn" data-act="dec">−</button>'
        + '<span class="syoat-qty__num">1</span>'
        + '<button type="button" class="syoat-qty__btn" data-act="inc">+</button>';
      btnWrap.insertBefore(wrap, btnWrap.firstChild);

      const numEl = wrap.querySelector('.syoat-qty__num');

      wrap.querySelector('[data-act="dec"]').addEventListener('click', function() {
        if (qty > 1) { qty--; numEl.textContent = qty; hiddenQty.value = qty; }
      });
      wrap.querySelector('[data-act="inc"]').addEventListener('click', function() {
        qty++; numEl.textContent = qty; hiddenQty.value = qty;
      });
    }
  }

  setTimeout(initStickyBar, 800);
  setTimeout(initStickyBar, 1500);
  window.addEventListener('scroll', function() {
    setTimeout(initStickyBar, 300);
  }, { once: true });
})();